







import { Component, Vue } from 'vue-property-decorator'
import FloorList from '@/components/floor/FloorList.vue'

@Component({
  components: {
    FloorList
  }
})

export default class Floor extends Vue {}
